var map = {
	"./pokemons/1.png": 99561,
	"./pokemons/10.png": 97005,
	"./pokemons/100.png": 39257,
	"./pokemons/101.png": 23504,
	"./pokemons/102.png": 88907,
	"./pokemons/103.png": 25250,
	"./pokemons/104.png": 34397,
	"./pokemons/105.png": 96916,
	"./pokemons/106.png": 35727,
	"./pokemons/107.png": 50630,
	"./pokemons/108.png": 90433,
	"./pokemons/109.png": 17720,
	"./pokemons/11.png": 70852,
	"./pokemons/110.png": 36862,
	"./pokemons/111.png": 89351,
	"./pokemons/112.png": 86700,
	"./pokemons/113.png": 22613,
	"./pokemons/114.png": 98842,
	"./pokemons/115.png": 46595,
	"./pokemons/116.png": 9736,
	"./pokemons/117.png": 3601,
	"./pokemons/118.png": 42646,
	"./pokemons/119.png": 39583,
	"./pokemons/12.png": 84415,
	"./pokemons/120.png": 559,
	"./pokemons/121.png": 77894,
	"./pokemons/122.png": 59101,
	"./pokemons/123.png": 26068,
	"./pokemons/124.png": 75979,
	"./pokemons/125.png": 54850,
	"./pokemons/126.png": 10937,
	"./pokemons/127.png": 4688,
	"./pokemons/128.png": 24599,
	"./pokemons/129.png": 79022,
	"./pokemons/13.png": 6326,
	"./pokemons/130.png": 44484,
	"./pokemons/131.png": 24077,
	"./pokemons/132.png": 92310,
	"./pokemons/133.png": 46111,
	"./pokemons/134.png": 18080,
	"./pokemons/135.png": 42281,
	"./pokemons/136.png": 94098,
	"./pokemons/137.png": 99291,
	"./pokemons/138.png": 11628,
	"./pokemons/139.png": 23253,
	"./pokemons/14.png": 80585,
	"./pokemons/140.png": 55949,
	"./pokemons/141.png": 29796,
	"./pokemons/142.png": 43359,
	"./pokemons/143.png": 65270,
	"./pokemons/144.png": 39529,
	"./pokemons/145.png": 84704,
	"./pokemons/146.png": 39739,
	"./pokemons/147.png": 74386,
	"./pokemons/148.png": 26389,
	"./pokemons/149.png": 43500,
	"./pokemons/15.png": 25760,
	"./pokemons/150.png": 45186,
	"./pokemons/16.png": 80795,
	"./pokemons/17.png": 15442,
	"./pokemons/18.png": 67445,
	"./pokemons/19.png": 84556,
	"./pokemons/2.png": 34418,
	"./pokemons/20.png": 75112,
	"./pokemons/21.png": 89329,
	"./pokemons/22.png": 59162,
	"./pokemons/23.png": 60387,
	"./pokemons/24.png": 46572,
	"./pokemons/25.png": 15669,
	"./pokemons/26.png": 48318,
	"./pokemons/27.png": 66631,
	"./pokemons/28.png": 6048,
	"./pokemons/29.png": 77225,
	"./pokemons/3.png": 83419,
	"./pokemons/30.png": 56307,
	"./pokemons/31.png": 40746,
	"./pokemons/32.png": 81825,
	"./pokemons/33.png": 60696,
	"./pokemons/34.png": 5220,
	"./pokemons/35.png": 83342,
	"./pokemons/36.png": 11173,
	"./pokemons/37.png": 58908,
	"./pokemons/38.png": 80299,
	"./pokemons/39.png": 89794,
	"./pokemons/4.png": 89828,
	"./pokemons/40.png": 77918,
	"./pokemons/41.png": 30407,
	"./pokemons/42.png": 11404,
	"./pokemons/43.png": 63669,
	"./pokemons/44.png": 39898,
	"./pokemons/45.png": 87651,
	"./pokemons/46.png": 50792,
	"./pokemons/47.png": 44657,
	"./pokemons/48.png": 67350,
	"./pokemons/49.png": 80639,
	"./pokemons/5.png": 15981,
	"./pokemons/50.png": 80313,
	"./pokemons/51.png": 64560,
	"./pokemons/52.png": 29963,
	"./pokemons/53.png": 66306,
	"./pokemons/54.png": 81482,
	"./pokemons/55.png": 37972,
	"./pokemons/56.png": 60431,
	"./pokemons/57.png": 91686,
	"./pokemons/58.png": 31489,
	"./pokemons/59.png": 58776,
	"./pokemons/6.png": 25302,
	"./pokemons/60.png": 85540,
	"./pokemons/61.png": 48781,
	"./pokemons/62.png": 33366,
	"./pokemons/63.png": 87167,
	"./pokemons/64.png": 59136,
	"./pokemons/65.png": 83337,
	"./pokemons/66.png": 18802,
	"./pokemons/67.png": 40347,
	"./pokemons/68.png": 36332,
	"./pokemons/69.png": 47957,
	"./pokemons/7.png": 3391,
	"./pokemons/70.png": 41615,
	"./pokemons/71.png": 2598,
	"./pokemons/72.png": 157,
	"./pokemons/73.png": 67124,
	"./pokemons/74.png": 17035,
	"./pokemons/75.png": 95906,
	"./pokemons/76.png": 51993,
	"./pokemons/77.png": 45744,
	"./pokemons/78.png": 65655,
	"./pokemons/79.png": 20078,
	"./pokemons/8.png": 96840,
	"./pokemons/80.png": 76570,
	"./pokemons/81.png": 66403,
	"./pokemons/82.png": 4424,
	"./pokemons/83.png": 52817,
	"./pokemons/84.png": 8254,
	"./pokemons/85.png": 84039,
	"./pokemons/86.png": 17004,
	"./pokemons/87.png": 28629,
	"./pokemons/88.png": 99474,
	"./pokemons/89.png": 21019,
	"./pokemons/9.png": 36785,
	"./pokemons/90.png": 71109,
	"./pokemons/91.png": 88220,
	"./pokemons/92.png": 46327,
	"./pokemons/93.png": 750,
	"./pokemons/94.png": 18465,
	"./pokemons/95.png": 97336,
	"./pokemons/96.png": 43091,
	"./pokemons/97.png": 4234,
	"./pokemons/98.png": 80829,
	"./pokemons/99.png": 47796,
	"./pokemons/Alolan/1.png": 39017,
	"./pokemons/Alolan/10.png": 59501,
	"./pokemons/Alolan/100.png": 37817,
	"./pokemons/Alolan/101.png": 31568,
	"./pokemons/Alolan/102.png": 61739,
	"./pokemons/Alolan/103.png": 71234,
	"./pokemons/Alolan/104.png": 32957,
	"./pokemons/Alolan/105.png": 95476,
	"./pokemons/Alolan/106.png": 16943,
	"./pokemons/Alolan/107.png": 35398,
	"./pokemons/Alolan/108.png": 63265,
	"./pokemons/Alolan/109.png": 42136,
	"./pokemons/Alolan/109a.png": 81091,
	"./pokemons/Alolan/109b.png": 95816,
	"./pokemons/Alolan/109c.png": 93681,
	"./pokemons/Alolan/10a.png": 38432,
	"./pokemons/Alolan/11.png": 96260,
	"./pokemons/Alolan/110.png": 13406,
	"./pokemons/Alolan/110a.png": 10261,
	"./pokemons/Alolan/110b.png": 24510,
	"./pokemons/Alolan/110c.png": 76999,
	"./pokemons/Alolan/111.png": 31719,
	"./pokemons/Alolan/112.png": 11660,
	"./pokemons/Alolan/113.png": 80757,
	"./pokemons/Alolan/114.png": 24250,
	"./pokemons/Alolan/115.png": 41827,
	"./pokemons/Alolan/115a.png": 4786,
	"./pokemons/Alolan/116.png": 56552,
	"./pokemons/Alolan/117.png": 54417,
	"./pokemons/Alolan/118.png": 42486,
	"./pokemons/Alolan/119.png": 38815,
	"./pokemons/Alolan/11a.png": 62583,
	"./pokemons/Alolan/12.png": 81535,
	"./pokemons/Alolan/120.png": 41871,
	"./pokemons/Alolan/120a.png": 93126,
	"./pokemons/Alolan/121.png": 73126,
	"./pokemons/Alolan/121a.png": 15661,
	"./pokemons/Alolan/122.png": 40541,
	"./pokemons/Alolan/123.png": 19412,
	"./pokemons/Alolan/123a.png": 84615,
	"./pokemons/Alolan/124.png": 11403,
	"./pokemons/Alolan/125.png": 47746,
	"./pokemons/Alolan/126.png": 61753,
	"./pokemons/Alolan/127.png": 46000,
	"./pokemons/Alolan/128.png": 19831,
	"./pokemons/Alolan/129.png": 29838,
	"./pokemons/Alolan/129a.png": 43589,
	"./pokemons/Alolan/129b.png": 71790,
	"./pokemons/Alolan/12a.png": 99734,
	"./pokemons/Alolan/12b.png": 81357,
	"./pokemons/Alolan/13.png": 44086,
	"./pokemons/Alolan/130.png": 8868,
	"./pokemons/Alolan/130a.png": 16695,
	"./pokemons/Alolan/130b.png": 9116,
	"./pokemons/Alolan/131.png": 62765,
	"./pokemons/Alolan/131a.png": 30912,
	"./pokemons/Alolan/132.png": 48790,
	"./pokemons/Alolan/137.png": 72731,
	"./pokemons/Alolan/14.png": 94057,
	"./pokemons/Alolan/143.png": 88790,
	"./pokemons/Alolan/143a.png": 9181,
	"./pokemons/Alolan/15.png": 69856,
	"./pokemons/Alolan/16.png": 51067,
	"./pokemons/Alolan/17.png": 29522,
	"./pokemons/Alolan/18.png": 58677,
	"./pokemons/Alolan/19.png": 47052,
	"./pokemons/Alolan/2.png": 90834,
	"./pokemons/Alolan/20.png": 45832,
	"./pokemons/Alolan/21.png": 85777,
	"./pokemons/Alolan/22.png": 61114,
	"./pokemons/Alolan/23.png": 82691,
	"./pokemons/Alolan/23a.png": 19346,
	"./pokemons/Alolan/24.png": 52524,
	"./pokemons/Alolan/24a.png": 65807,
	"./pokemons/Alolan/25.png": 35413,
	"./pokemons/Alolan/26.png": 49662,
	"./pokemons/Alolan/27.png": 20999,
	"./pokemons/Alolan/28.png": 93728,
	"./pokemons/Alolan/29.png": 48553,
	"./pokemons/Alolan/3.png": 12379,
	"./pokemons/Alolan/30.png": 21363,
	"./pokemons/Alolan/31.png": 66154,
	"./pokemons/Alolan/32.png": 15137,
	"./pokemons/Alolan/33.png": 30520,
	"./pokemons/Alolan/34.png": 22039,
	"./pokemons/Alolan/35.png": 56641,
	"./pokemons/Alolan/36.png": 50821,
	"./pokemons/Alolan/37.png": 21404,
	"./pokemons/Alolan/37a.png": 11039,
	"./pokemons/Alolan/38.png": 25003,
	"./pokemons/Alolan/38a.png": 33226,
	"./pokemons/Alolan/39.png": 3874,
	"./pokemons/Alolan/39a.png": 48657,
	"./pokemons/Alolan/4.png": 57572,
	"./pokemons/Alolan/40.png": 68702,
	"./pokemons/Alolan/40a.png": 25429,
	"./pokemons/Alolan/41.png": 87015,
	"./pokemons/Alolan/42.png": 50604,
	"./pokemons/Alolan/43.png": 36053,
	"./pokemons/Alolan/44.png": 79546,
	"./pokemons/Alolan/45.png": 80771,
	"./pokemons/Alolan/46.png": 95496,
	"./pokemons/Alolan/47.png": 9713,
	"./pokemons/Alolan/48.png": 81430,
	"./pokemons/Alolan/49.png": 77759,
	"./pokemons/Alolan/5.png": 20813,
	"./pokemons/Alolan/50.png": 93113,
	"./pokemons/Alolan/51.png": 86864,
	"./pokemons/Alolan/52.png": 683,
	"./pokemons/Alolan/53.png": 10178,
	"./pokemons/Alolan/53a.png": 75313,
	"./pokemons/Alolan/54.png": 71901,
	"./pokemons/Alolan/54a.png": 53744,
	"./pokemons/Alolan/55.png": 50772,
	"./pokemons/Alolan/55a.png": 82215,
	"./pokemons/Alolan/56.png": 55887,
	"./pokemons/Alolan/57.png": 90694,
	"./pokemons/Alolan/58.png": 2209,
	"./pokemons/Alolan/58a.png": 25372,
	"./pokemons/Alolan/58b.png": 26007,
	"./pokemons/Alolan/59.png": 81080,
	"./pokemons/Alolan/59a.png": 79907,
	"./pokemons/Alolan/59b.png": 94632,
	"./pokemons/Alolan/6.png": 89046,
	"./pokemons/Alolan/60.png": 47812,
	"./pokemons/Alolan/60a.png": 31863,
	"./pokemons/Alolan/61.png": 18061,
	"./pokemons/Alolan/61a.png": 29728,
	"./pokemons/Alolan/62.png": 87734,
	"./pokemons/Alolan/62a.png": 50877,
	"./pokemons/Alolan/63.png": 1023,
	"./pokemons/Alolan/64.png": 49696,
	"./pokemons/Alolan/65.png": 27817,
	"./pokemons/Alolan/66.png": 96850,
	"./pokemons/Alolan/67.png": 28027,
	"./pokemons/Alolan/68.png": 31788,
	"./pokemons/Alolan/69.png": 84053,
	"./pokemons/Alolan/7.png": 42847,
	"./pokemons/Alolan/70.png": 80815,
	"./pokemons/Alolan/71.png": 12070,
	"./pokemons/Alolan/72.png": 79485,
	"./pokemons/Alolan/73.png": 58356,
	"./pokemons/Alolan/74.png": 50347,
	"./pokemons/Alolan/75.png": 86690,
	"./pokemons/Alolan/76.png": 697,
	"./pokemons/Alolan/77.png": 84944,
	"./pokemons/Alolan/77a.png": 8619,
	"./pokemons/Alolan/78.png": 58775,
	"./pokemons/Alolan/78a.png": 85054,
	"./pokemons/Alolan/79.png": 85134,
	"./pokemons/Alolan/8.png": 95784,
	"./pokemons/Alolan/80.png": 24602,
	"./pokemons/Alolan/81.png": 88707,
	"./pokemons/Alolan/82.png": 51848,
	"./pokemons/Alolan/83.png": 45713,
	"./pokemons/Alolan/84.png": 78974,
	"./pokemons/Alolan/85.png": 31463,
	"./pokemons/Alolan/86.png": 12460,
	"./pokemons/Alolan/87.png": 64725,
	"./pokemons/Alolan/88.png": 77522,
	"./pokemons/Alolan/89.png": 8699,
	"./pokemons/Alolan/9.png": 27825,
	"./pokemons/Alolan/90.png": 68229,
	"./pokemons/Alolan/91.png": 50716,
	"./pokemons/Alolan/92.png": 39447,
	"./pokemons/Alolan/93.png": 65806,
	"./pokemons/Alolan/94.png": 32545,
	"./pokemons/Alolan/95.png": 59832,
	"./pokemons/Alolan/96.png": 34323,
	"./pokemons/Alolan/96a.png": 3938,
	"./pokemons/Alolan/97.png": 83562,
	"./pokemons/Alolan/97a.png": 99785,
	"./pokemons/Alolan/98.png": 60157,
	"./pokemons/Alolan/99.png": 39028,
	"./pokemons/Alolan/99a.png": 59655
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96657;